declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData } from '../../../../../../models/actor/actor';


@Component({
  selector: 'auto-gen-date',
  templateUrl: './autogendate.component.html',
  styleUrls: ['./autogendate.component.scss']
})

export class AutoGenDateComponent implements OnInit {
  @Input() public mode;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedDate: NgbDateStruct;
  TodayDate = new Date();
  @Input() public field: FieldData;
  constructor(private router: Router,
    private parserFormatter: NgbDateParserFormatter) {

    //stepObject.init();
    //webGlObject.init();
    //this.LMPDate = this.SelectedpatientDetails.LMP;
  }
  ngOnInit(): void {
    this.SelectedDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    //this.field.Value = this.parserFormatter.format(this.SelectedDate);
    if (this.field.Value != null) {
      var SValidFrom = new Date(this.field.Value);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.SelectedDate = {
          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
  }
  onChange2(event: any) {
    //this.SelectedSource = event;
    // alert(this.SelectedSource)
    //this.field.Value = this.SelectedDate;
    this.field.Value = this.parserFormatter.format(event);
    // alert(this.field.Value);

  }

  //get selDate(): Date {
  //    var d: Date = Date.n;
  //    if (this.field != null)
  //        return Date.parse()
  //    return ( && this.field.Value == 'True');
  //}

  //@Input('selDate')
  //set selDate(value: boolean) {
  //    this.field != null
  //    {
  //        //  alert(this.field.Title + " before: " + this.field.Value + "  , New Value = " + value);
  //        if (value)
  //            this.field.Value = 'True';
  //        else
  //            this.field.Value = 'False';

  //        //  alert(this.field.Title + " After: " + this.field.Value );
  //    }
  //}

  //get isChecked(): Date {
  //    return (this.field != null && Date.parse(this.field.Value == 'True');
  //}

  //@Input('date')
  //set isChecked(value: Date) {
  //    this.field != null
  //    {
  //        alert(this.field.Title + " before: " + this.field.Value + "  , New Value = " + value);
  //        if (value)
  //            this.field.Value = 'True';
  //        else
  //            this.field.Value = 'False';

  //        alert(this.field.Title + " After: " + this.field.Value );
  //    }
  //}
}
